import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Product } from '../models/product.model';
import { MrpScrolltopComponent } from '../services/mrp-scrolltop/mrp-scrolltop.component';

import { FooterComponent } from '../footer/footer.component'; 
import { CommonModule, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-adv-class',
    templateUrl: './adv-class.component.html',
    styleUrls: ['./adv-class.component.css'],
    imports: [CommonModule, MrpScrolltopComponent, RouterLink, FooterComponent]
})
export class AdvClassComponent implements OnInit {

 classes: Product[] = [];
  displayedColumns: string[] = ['name', 'description', 'price', 'action'];
  isLoading = false;
  isInitiatingCheckout = false;
  isBrowser = false;

  constructor(private router: Router, private http: HttpClient, public auth: AuthService, 
    @Inject(PLATFORM_ID) private platformId: Object, private cdr: ChangeDetectorRef) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

     this.isLoading = true;
     if (this.isBrowser) {
          this.http.post<Product[]>('api/products/getAdvClasses.php', {}).subscribe({
              next: (data) => {
                this.classes = data;
                this.isLoading = false;
                this.cdr.markForCheck();
              },
              error: (error) => {
                console.error('Error fetching products:', error);
                this.isLoading = false;
                this.cdr.markForCheck();
              }
            });
          this.logPage('adv-class');
     } else {
       this.isLoading = false;
     }
  }

  logPage(urlName: string): void {
    if (!this.isBrowser) return;
    this.http.post('/api/access/access_log.php', {urlName: urlName}).subscribe();
  }


  gotoClass(item_CODE: string){
      this.router.navigate(['/adv-detail', item_CODE]);  
  }

  isSubscriber(){
    return this.auth.currentUser.isSubscriber;
  }

  hasSubscribed(){
    return this.auth.currentUser.hasSubscribed;
  }

  isLoggedIn(){
    // Prefer the BehaviorSubject's current value for template checks so UI updates reliably
    // Fall back to legacy method if tests or environment provide an older AuthService stub
    if (this.auth && (this.auth as any).loggedIn$ && typeof (this.auth as any).loggedIn$.getValue === 'function') {
      return (this.auth as any).loggedIn$.getValue();
    }
    return this.auth.isLoggedIn();
  }

  async initiateCheckout(priceId: string, mode: 'subscription') {
    this.isInitiatingCheckout = true;
    this.http.post<{ sessionId: string, stripeKey: string, sessionUrl: string }>('api/create-checkout-session/create-checkout-session.php', { priceId, mode }).subscribe({
      next: async (response) => {
        this.redirectTo(response.sessionUrl);
      },
      error: (error) => {
        this.isInitiatingCheckout = false;
        console.error('Error creating checkout session:', error);
        this.cdr.markForCheck();
      }
    });
  }

  scrollTo(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      // Use scrollIntoView with 'smooth' behavior for a nice effect
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Wrapper to make redirects testable
  redirectTo(url: string): void {
    window.location.assign(url);
  }

}
